"use client";
import { Suspense, useLayoutEffect, useRef } from "react";
import dynamic from "next/dynamic";
import { Box, Stack } from "@mui/material";

import { useStore, observer } from "../../../service/mobx";

const Message = dynamic(() => import("./Message"));

function ChatMessages() {
  const { agent } = useStore();
  const ref = useRef();
  const lastMessage = agent.history.at(-1);

  useLayoutEffect(() => {
    if (lastMessage) {
      ref.current.scrollIntoViewIfNeeded();

      const id = setTimeout(() => ref.current.scrollIntoViewIfNeeded(), 300);

      return () => clearTimeout(id);
    }
  }, [lastMessage]);

  return (
    <Stack useFlexGap spacing={6} px={2} height="100%">
      {agent.history.map((message, index) => (
        <Suspense key={message.userMessage ? index : message.id}>
          <Message message={message} index={index} />
        </Suspense>
      ))}
      <Box height={80} ref={ref} />
    </Stack>
  );
}

export default observer(ChatMessages);
